import './App.css'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import LandingRoutes from './routes'

function App() {
  return (
    <div className='w-full  min-h-screen flex flex-col'>
      <Navbar />
      <div className="flex-1 bg-emerald-50 overflow-hidden">
        <LandingRoutes />
      </div>
      <Footer />
    </div>
  )
}

export default App
